import { useWarrantyLogsModalStore } from '../../model/use-warranty-logs-modal.store';
import { SearchComponent } from '../search-component';
import { SelectBranch } from '../select-branch/select-branch';
import { SelectManufacturers } from '../select-manufacturers/select-manufacturers';
import { SelectStatus } from '../select-status/select-status';
import { SelectWaAdmin } from '../select-wa-admin/select wa-admin';
import { SelectWaStatus } from '../select-wa-status/select-wa-status';
import { SelectWarrantyType } from '../select-warranty-type/select-warranty-type';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { useQueryRequest } from 'components/table/contexts/query-request';
import { WarrantyLogFilter } from 'entities/warranty';
import { Button, DateInput } from 'shared';

export const Header = () => {
  const { showCreateModal } = useWarrantyLogsModalStore();

  const { updateState, state: currentState } = useQueryRequest();
  const filter: WarrantyLogFilter = currentState.filter || {};

  const onChangeDateFrom = (date?: string | null) => {
    updateState({
      filter: {
        ...filter,
        fromDate: date
      }
    });
  };

  const onChangeDateTo = (date?: string | null) => {
    updateState({
      filter: {
        ...filter,
        toDate: date
      }
    });
  };

  const onChangeRegNo = (val?: string) => {
    updateState({
      filter: {
        ...filter,
        regNo: val?.trim()
      }
    });
  };

  const onChangeWIPNo = (val?: string) => {
    updateState({
      filter: {
        ...filter,
        wipNo: val?.trim()
      }
    });
  };

  const toDate = (date?: string) => (date ? new Date(date) : new Date());

  const onChangeBranch = (val?: number) => {
    updateState({
      filter: {
        ...filter,
        branch: val
      }
    });
  };

  const onChangeManufacturer = (val?: number) => {
    updateState({
      filter: {
        ...filter,
        manufacturerId: val
      }
    });
  };

  const onChangeWarrantyType = (val?: number[]) => {
    updateState({
      filter: {
        ...filter,
        warrantyTypeIds: val
      }
    });
  };

  const onChangeWaStatuses = (val?: number[]) => {
    updateState({
      filter: {
        ...filter,
        waStatuses: val
      }
    });
  };

  const onChangeStatuses = (val?: number[]) => {
    updateState({
      filter: {
        ...filter,
        warrantyLogStatuses: val
      }
    });
  };

  return (
    <div className={styles.container}>
      <div className={clsx(styles.firstRow, styles.row)}>
        <div className={styles.filterContainer}>
          <div className={styles.dateContainer}>
            <div style={{ flex: 1 }}>
              <DateInput
                value={filter?.fromDate ? toDate(filter?.fromDate) : undefined}
                isSmallSize={true}
                onDateChange={(value) => {
                  onChangeDateFrom(value);
                }}
                position={'below left'}
                maxDate={toDate(filter?.toDate)}
                placeholder="Date from"
              />
            </div>
            <div>-</div>
            <div style={{ flex: 1 }}>
              <DateInput
                value={filter?.toDate ? toDate(filter?.toDate) : undefined}
                isSmallSize={true}
                onDateChange={(value) => {
                  onChangeDateTo(value);
                }}
                position={'below right'}
                minDate={toDate(filter?.fromDate)}
                placeholder="Date to"
              />
            </div>
          </div>

          <div className={styles.searchContainer}>
            <SearchComponent currentValue={filter?.regNo ?? ''} placeholder={'Reg N'} onTextChange={onChangeRegNo} />
            <SearchComponent
              currentValue={filter?.wipNo?.toString() ?? ''}
              placeholder={'WIP No'}
              onTextChange={onChangeWIPNo}
            />
          </div>
        </div>
        <div>
          <Button
            text="Add New"
            icon={<InlineSvg path="/media/icons/custom/plus.svg" />}
            additionalClass={styles.addBtn}
            onClick={showCreateModal}
          />
        </div>
      </div>
      <div className={clsx(styles.row, styles.secondRow)}>
        <div className={styles.selectControl}>
          <SelectBranch
            branch={filter?.branch}
            onChange={onChangeBranch}
            placeholder="All Branches"
            isClearable={true}
          />
        </div>
        <div className={styles.selectControl}>
          <SelectManufacturers
            manufacturerId={filter?.manufacturerId}
            onChange={onChangeManufacturer}
            placeholder="All Manufacturers"
            isClearable={true}
          />
        </div>
        <div className={styles.selectControl}>
          <SelectWarrantyType
            warrantyTypeIds={filter?.warrantyTypeIds}
            onChange={onChangeWarrantyType}
            placeholder="Any Warranty Type"
            isClearable={true}
            isMulti={true}
          />
        </div>
        <div className={styles.selectControl}>
          <SelectWaAdmin />
        </div>
        <div className={styles.selectControl}>
          <SelectWaStatus
            statuses={filter?.waStatuses}
            onChange={onChangeWaStatuses}
            placeholder="Any WA Status"
            isClearable={true}
            isMulti={true}
          />
        </div>
        <div className={styles.selectControl}>
          <SelectStatus
            statuses={filter?.warrantyLogStatuses}
            onChange={onChangeStatuses}
            placeholder="Any Status"
            isClearable={true}
            isMulti={true}
          />
        </div>
      </div>
    </div>
  );
};
